import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { TITLE_BAR_HEIGHT, TASKBAR_HEIGHT } from '@/constants';
import { TitleBar } from './TitleBar';

const WindowRoot = styled(Box)(({ theme }) => ({
  position: 'relative',
  height: '100%',
  width: '100%',
  border: `2px solid ${theme.palette.divider}`,
  overflow: 'hidden',
}));

const ContentArea = styled(Box)(({ theme }) => ({
  height: `calc(100% - ${TITLE_BAR_HEIGHT} - ${TASKBAR_HEIGHT})`,
  padding: theme.spacing(3),
  overflow: 'auto',
  position: 'relative',
}));

export function TerminalWindow({
  title = 'terminal',
  onClose,
  children,
}: {
  title?: string;
  onClose?: () => void;
  children: React.ReactNode;
}) {
  const navigate = useNavigate();

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (onClose) {
          onClose();
        } else {
          navigate('/');
        }
      }
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [navigate, onClose]);

  return (
    <WindowRoot>
      <TitleBar title={title} onClose={onClose} />
      <ContentArea>{children}</ContentArea>
    </WindowRoot>
  );
}
